export enum Relationship {
  FATHER = "FATHER",
  MOTHER = "MOTHER",
  OTHER = "OTHER",
}
